import "./PMDashboard.css";
import React, { useState, useEffect } from "react";
import { format, isSameDay } from "date-fns";
import Select from "react-select";
import {

    zoneAttendaceWithDistrict,
    zoneAttendaceWithoutDistrict,
    getPresentEmployeesStatePM,
    getAbsentEmployeesStatePM,
    getNotInLocationEmployeesStatePM,
    attendaceWithoutStatePM,
    getAllEmployeesStatePM,
    getPresentEmployeesZone,
    getAbsentEmployeesZone,
    getNotInLocationEmployeesZone,
    getAllEmployeesZone,
} from "../../../../services/dashboard";
import { getAllDistrictBihar, getDistrictByZoneId, getAllDistrictBiharZD } from "../../../../services/monthlyAttendanceService";
import { handleSortByTimeDirectArray } from "../../../../utils/sortingOrderByTime";

const PMDashboard = () => {
    const [groupedOptions, setGroupedOptions] = useState([]);
    const [selectedZone, setSelectedZone] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");
    const [isFocused, setIsFocused] = useState({ district: false });
    const today = new Date();
    const [districtOptions, setDistrictOptions] = useState([]);
    const [district, setDistrict] = useState("");
    const [districtId, setDistrictId] = useState("");
    const [sameDayAttendance, setSameDayAttendance] = useState(null);
    const employeeUniqueId = localStorage.getItem("employeeUniqueIdLogin");
    const stateName = localStorage.getItem("stateName");
    const stateId = localStorage.getItem("stateId");
    const [errors, setErrors] = useState({});
    const [differenceDayAttendace, setDifferenceDayAttendance] = useState({});
    const [userData, setUSerData] = useState([]);
    const [startDate, setStartDate] = useState(today);
    const [displayMode, setDisplayMode] = useState("all");
    const [filteredRecords, setFilteredRecords] = useState([]);
    const [filterLoading, setFilterLoading] = useState(false);
    const [filterError, setFilterError] = useState(null);
    const [filterTitle, setFilterTitle] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const paginatedDistricts = differenceDayAttendace?.districts?.slice(indexOfFirstRecord, indexOfLastRecord) || [];

    const totalPages = Math.ceil((differenceDayAttendace?.districts?.length || 0) / recordsPerPage);
    const [empCurrentPage, setEmpCurrentPage] = useState(1);
    const empRecordsPerPage = 15;

    const empIndexOfLast = empCurrentPage * empRecordsPerPage;
    const empIndexOfFirst = empIndexOfLast - empRecordsPerPage;
    const paginatedEmployees = filteredRecords.slice(empIndexOfFirst, empIndexOfLast);

    const empTotalPages = Math.ceil(filteredRecords.length / empRecordsPerPage);
    useEffect(() => {

        // 🚫 If zone selected, DO NOT CALL STATE API inside useEffect
        if (selectedZone) return;

        const fetchAttendance = async () => {
            try {
                if (district && district !== "DIST_ALL") {
                    const data = await zoneAttendaceWithDistrict(district, today);
                    setSameDayAttendance(data);
                    setFilteredRecords(data.records || []);
                } else {
                    const data = await attendaceWithoutStatePM(stateId, today);
                    setDifferenceDayAttendance(data);
                    setSameDayAttendance(null);
                }
            } catch (e) {
                console.error(e);
            } finally {
                setFilterLoading(false);
            }
        };

        fetchAttendance();

    }, [district, stateId, selectedZone]);



    const getDistrictsAll = async () => {
        const data = await getAllDistrictBiharZD();

        // 🔐 SAFETY CHECKS
        if (!data) {
            console.error("API returned empty");
            return;
        }

        const zones = Array.isArray(data.zones) ? data.zones : [];
        const districts = Array.isArray(data.districts) ? data.districts : [];

        // Zones
        const zoneOptions = zones.map(z => ({
            label: z.zoneName,
            value: `ZONE_${z.zoneId}`,
            type: "zone",
            zoneId: z.zoneId
        }));

        // const districtOptions = [
        //     {
        //         label: "All Districts",
        //         value: "DIST_ALL",
        //         type: "district_all"
        //     },
        //     ...districts.map(d => ({
        //         label: d.districtName,
        //         value: `DIST_${d.districtId}`,
        //         type: "district",
        //         districtId: d.districtId,
        //         zoneId: d.zoneId
        //     }))
        // ];

        setGroupedOptions([
            {
                // label: "Quick Filters",
                options: [
                    {
                        label: "All",
                        value: "DIST_ALL",
                        type: "district_all"
                    }
                ]
            },
            {
                label: "Zones",
                options: zoneOptions
            },
            {
                label: "Districts",
                options: districts.map(d => ({
                    label: d.districtName,
                    value: `DIST_${d.districtId}`,
                    type: "district",
                    districtId: d.districtId,
                    zoneId: d.zoneId
                }))
            }
        ]);

    };


    const handleSelection = (option) => {
        if (!option) return;

        // ZONE SELECTED
        if (option.type === "zone") {
            setSelectedZone(option.zoneId);
            setDistrict(null);
            callZoneAPI(option.zoneId);
            return;
        }

        // SINGLE DISTRICT SELECTED
        if (option.type === "district") {
            setSelectedZone(null);
            setDistrict(option.districtId);
            callDistrictAPI(option.districtId);
            return;
        }

        // ALL DISTRICTS SELECTED
        if (option.type === "district_all") {
            setSelectedZone(null);
            setDistrict("DIST_ALL");

            // 🔥 CALL YOUR STATE API HERE
            attendaceWithoutStatePM(stateId, today)
                .then(data => {
                    setDifferenceDayAttendance(data);
                    setSameDayAttendance(null);
                })
                .catch(console.error);

            return;
        }
    };

    useEffect(() => {
        getDistrictsAll();
    }, []);

    const callZoneAPI = (zoneId) => {
        zoneAttendaceWithoutDistrict(zoneId, today)
            .then(setDifferenceDayAttendance)
            .catch(console.error);
    };

    const callDistrictAPI = (districtId) => {
        zoneAttendaceWithDistrict(districtId, today)
            .then(setSameDayAttendance)
            .catch(console.error);
    };

    // const getDistrictsAll = async () => {
    //     const data = await getAllDistrictBihar();
    //     if (data) {
    //         const options = data.map(d => ({
    //             value: d.districtId,
    //             label: d.districtName,
    //         }));
    //         setDistrictOptions(options);
    //     }
    // };

    // useEffect(() => {

    //     getDistrictsAll();

    // }, []);

    const fetchAndShow = async (apiFn, mode, title) => {
        setFilterLoading(true);
        setFilterError(null);
        try {
            let data;

            if (district && district !== 'DIST_ALL') {
                // Pass: stateId, date, district
                data = await apiFn(stateId, today, district);
            } else {
                // Pass: stateId, date, NO district
                data = await apiFn(stateId, today, null);
            }

            setFilteredRecords(Array.isArray(data.records) ? data.records : []);
            setDisplayMode(mode);
            setFilterTitle(title);
            setEmpCurrentPage(1);
        } catch (e) {
            setFilterError("Failed to load data");
            setFilteredRecords([]);
        } finally {
            setFilterLoading(false);
        }
    };

    const showAllEmployees = async () => {
        setFilterLoading(true);
        setFilterError(null);

        try {
            if (district && district !== 'DIST_ALL') {
                // 🟢 Return to district employee list
                const data = await zoneAttendaceWithDistrict(district, today);
                setFilteredRecords(data.records || []);
                setDisplayMode("all");
                setFilterTitle("");
                setEmpCurrentPage(1);
            } else {
                // 🟢 Return to full-state employee list (NOT district summary)
                const data = await getAllEmployeesStatePM(stateId, today, null);
                setFilteredRecords(data.records || []);
                setDisplayMode("all");
                setFilterTitle(`All Employees – ${format(today, "dd-MM-yyyy")}`);
                setEmpCurrentPage(1);
            }
        } catch (e) {
            setFilterError("Failed to load data");
            setFilteredRecords([]);
        } finally {
            setFilterLoading(false);
        }
    };

    const showPresent = async () => {
        setFilterLoading(true);
        setFilterError(null);

        try {
            let data;

            if (selectedZone) {
                // ✅ ZONE API → zoneId ONLY
                data = await getPresentEmployeesZone(selectedZone, today, null);
            }
            else if (district && district !== "DIST_ALL") {
                // ✅ DISTRICT API
                data = await getPresentEmployeesStatePM(stateId, today, district);
            }
            else {
                // ✅ STATE API
                data = await getPresentEmployeesStatePM(stateId, today, null);
            }

            setFilteredRecords(data?.records || []);
            setDisplayMode("present");
            setFilterTitle(`Present Employees – ${format(today, "dd-MM-yyyy")}`);
            setEmpCurrentPage(1);

        } catch (e) {
            setFilterError("Failed to load data");
            setFilteredRecords([]);
        } finally {
            setFilterLoading(false);
        }
    };
    const showAbsent = async () => {
        setFilterLoading(true);
        setFilterError(null);

        try {
            let data;

            if (selectedZone) {
                // ZONE API
                data = await getAbsentEmployeesZone(selectedZone, today, null);
            }
            else if (district && district !== "DIST_ALL") {
                // DISTRICT API
                data = await getAbsentEmployeesStatePM(stateId, today, district);
            }
            else {
                // STATE API
                data = await getAbsentEmployeesStatePM(stateId, today, null);
            }

            setFilteredRecords(data?.records || []);
            setDisplayMode("absent");
            setFilterTitle(`Absent Employees – ${format(today, "dd-MM-yyyy")}`);
            setEmpCurrentPage(1);

        } catch (e) {
            setFilterError("Failed to load data");
            setFilteredRecords([]);
        } finally {
            setFilterLoading(false);
        }
    };
    const showNotInLocation = async () => {
        setFilterLoading(true);
        setFilterError(null);

        try {
            let data;

            if (selectedZone) {
                // ZONE API
                data = await getNotInLocationEmployeesZone(selectedZone, today, null);
            }
            else if (district && district !== "DIST_ALL") {
                // DISTRICT API
                data = await getNotInLocationEmployeesStatePM(stateId, today, district);
            }
            else {
                // STATE API
                data = await getNotInLocationEmployeesStatePM(stateId, today, null);
            }

            setFilteredRecords(data?.records || []);
            setDisplayMode("notInLocation");
            setFilterTitle(`Not-in-Location – ${format(today, "dd-MM-yyyy")}`);
            setEmpCurrentPage(1);

        } catch (e) {
            setFilterError("Failed to load data");
            setFilteredRecords([]);
        } finally {
            setFilterLoading(false);
        }
    };
    const showAllEmployeesAll = async () => {
        setFilterLoading(true);
        setFilterError(null);

        try {
            let data;

            if (selectedZone) {
                // ZONE API
                data = await getAllEmployeesZone(selectedZone, today, null);
            }
            else if (district && district !== "DIST_ALL") {
                // DISTRICT API
                data = await getAllEmployeesStatePM(stateId, today, district);
            }
            else {
                // STATE API
                data = await getAllEmployeesStatePM(stateId, today, null);
            }

            setFilteredRecords(data?.records || []);
            setDisplayMode("allEmployes");
            setFilterTitle(`All Employees – ${format(today, "dd-MM-yyyy")}`);
            setEmpCurrentPage(1);

        } catch (e) {
            setFilterError("Failed to load data");
            setFilteredRecords([]);
        } finally {
            setFilterLoading(false);
        }
    };

    // const showPresent = () => fetchAndShow(district ? getPresentEmployeesStatePM : getPresentEmployeesZone, "present", `Present Employees – ${format(today, "dd-MM-yyyy")}`);
    // const showAbsent = () => fetchAndShow(getAbsentEmployeesStatePM, "absent", `Absent Employees – ${format(today, "dd-MM-yyyy")}`);
    //  const showNotInLocation = () => fetchAndShow(getNotInLocationEmployeesStatePM, "notInLocation", `Not-in-Location – ${format(today, "dd-MM-yyyy")}`);
    //  const showAllEmployeesAll = () => fetchAndShow(getAllEmployeesStatePM, "allEmployes", `All-Employes– ${format(today, "dd-MM-yyyy")}`)
    // const handleInputChange = (selectedOption, field) => {
    //     const value = selectedOption ? selectedOption.value : "";
    //     switch (field) {
    //         case "district":
    //             setDistrict(value);
    //             setDistrictId(value);
    //             setEmpCurrentPage(1);
    //             break;
    //         default:
    //             break;
    //     }
    //     setErrors(prev => ({ ...prev, [field]: null }));
    // };

    const renderRows = () => {
        if (filterLoading) return <tr><td colSpan={10} className="text-center">Loading…</td></tr>;
        if (filterError) return <tr><td colSpan={10} className="text-center text-danger">{filterError}</td></tr>;
        if (!filteredRecords.length) return <tr><td colSpan={10} className="text-center">No data</td></tr>;

        return paginatedEmployees.map((r, i) => (
            <tr key={i}>
                <td>{empIndexOfFirst + i + 1}</td>
                <td className="text-start">{r.employeeName ?? "-"}</td>
                <td>{r.designation ?? "-"}</td>
{/* ⭐ WorkLocation / Godown Logic */}
    <td>
        {r.isWorkLocation === true
            ? (r.workLocationName?.trim() || "-")
            : (r.godownName?.trim() || "-")}
    </td>                <td>{r.contactNumber ?? "-"}</td>
                <td>{r.attendanceStatus ?? "-"}</td>
                <td>{r.attendanceTime ?? "-"}</td>

                <td>
                    {r.attendanceStatus === "Present" && (!r.remarks || r.remarks === "")
                        ? "In the location"
                        : r.remarks && r.attendanceStatus === "Present"
                            ? "Not in the location"
                            : "-"}
                </td>

                <td>{r.remarks ?? "-"}</td>

                <td>
                    {r.selfieUrl ? (
                        <a
                            href={r.selfieUrl.startsWith("http") ? r.selfieUrl : `${process.env.REACT_APP_FILE_BASE_URL}/${r.selfieUrl}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            View
                        </a>
                    ) : "-"}
                </td>
            </tr>
        ));
    };

    return (
        <div className="pm-dashboard-page">
            <div className="pm-new-dashboard-dash">
                <div className="pm-current-month-date-dash">
                    <h2>PM Dashboard - {stateName}</h2>
                </div>
                <div className="d-flex justify-content-center align-items-center mt-2">
                    <div className="mb-0"><label>District : </label></div>
                    <div style={{ minWidth: "200px" }}>
                        <Select
                            options={groupedOptions}
                            onChange={handleSelection}
                            placeholder="Select Zone or District"
                            isClearable
                            className="w-100"
                        />

                    </div>
                </div>
                <div className="pm-current-month-dash">
                    <div className="select-date-text-dash">
                        <div className="month-text-dash">Attendance on : {format(today, "dd-MM-yyyy")}</div>
                    </div>
                    <div className="pm-content-data-for-month-dash">
                        <div
                            className={`pm-present-days-dash ${displayMode === "present" ? "active" : ""}`}
                            onClick={showPresent}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="pm-data-user-values1">
                                {district && district !== 'DIST_ALL' ? sameDayAttendance?.presentCount ?? 0 : differenceDayAttendace?.totalPresent ?? 0}
                            </div>
                            <div className="pm-data-user-label">No of Present</div>
                        </div>
                        <div
                            className={`pm-present-days-dash ${displayMode === "absent" ? "active" : ""}`}
                            onClick={showAbsent}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="pm-data-user-values2">
                                {district && district !== 'DIST_ALL' ? sameDayAttendance?.absentCount ?? 0 : differenceDayAttendace?.totalAbsent ?? 0}
                            </div>
                            <div className="pm-data-user-label">No of Absent</div>
                        </div>
                        <div
                            className={`pm-present-days-dash leave-card ${displayMode === "notInLocation" ? "active" : ""}`}
                            onClick={showNotInLocation}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="pm-data-user-values3">
                                {district && district !== 'DIST_ALL' ? sameDayAttendance?.remarksCount ?? 0 : differenceDayAttendace?.totalNotInLocation ?? 0}
                            </div>
                            <div className="pm-data-user-label">Not in the location</div>
                        </div>
                        <div

                            className={`pm-present-days-dash leave-card ${displayMode === "all" ? "active" : ""}`}
                            onClick={showAllEmployeesAll}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="pm-data-user-values3">
                                {district && district !== 'DIST_ALL' ? sameDayAttendance?.totalEmployeeCount ?? 0 : differenceDayAttendace?.totalEmployees ?? 0}
                            </div>
                            <div className="pm-data-user-label">Total No of Employees</div>
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
                    <h5 className="mb-0">{filterTitle}</h5>
                    {displayMode !== "all" && (
                        <button className="btn btn-sm btn-outline-primary" onClick={showAllEmployees}>
                            Show All
                        </button>
                    )}
                </div>

                {(district && district !== 'DIST_ALL' || displayMode !== "all") && (
                    <div className="pm-table-for-emp">
                        <table className="pm-table-dash">
                            <thead className="pm-table-head-dash">
                                <tr>
                                    <th>S.No</th>
                                    <th>Employee Name</th>
                                    <th>Designation</th>
                                    <th>Working Location</th>
                                    <th>Mobile Number</th>
                                    <th>Attendance Status</th>
                                    <th
                                        onClick={() =>
                                            handleSortByTimeDirectArray(sortOrder, setSortOrder, filteredRecords, setFilteredRecords)
                                        }
                                        style={{ cursor: "pointer" }}
                                    >
                                        Attendance Time {sortOrder === "asc" ? "▲" : "▼"}
                                    </th>


                                    <th>Location Status</th>
                                    <th>Remarks</th>
                                    <th>Attendance Photo</th>
                                </tr>
                            </thead>
                            <tbody className="table-body-dash">{renderRows()}</tbody>
                        </table>
                        {(district || displayMode !== "all") && filteredRecords.length > 0 && (
                            <div className="d-flex justify-content-center my-3">

                                {/* Prev Button */}
                                <button
                                    className="circle-btn"
                                    disabled={empCurrentPage === 1}
                                    onClick={() => setEmpCurrentPage(prev => prev - 1)}
                                >
                                    ‹
                                </button>

                                {/* Previous Page Number */}
                                {empCurrentPage > 1 && (
                                    <button
                                        className="circle-btn"
                                        onClick={() => setEmpCurrentPage(empCurrentPage - 1)}
                                    >
                                        {empCurrentPage - 1}
                                    </button>
                                )}

                                {/* Current Page */}
                                <button className="circle-btn active-circle">
                                    {empCurrentPage}
                                </button>

                                {/* Next Page Number */}
                                {empCurrentPage < empTotalPages && (
                                    <button
                                        className="circle-btn"
                                        onClick={() => setEmpCurrentPage(empCurrentPage + 1)}
                                    >
                                        {empCurrentPage + 1}
                                    </button>
                                )}

                                {/* Next Button */}
                                <button
                                    className="circle-btn"
                                    disabled={empCurrentPage === empTotalPages}
                                    onClick={() => setEmpCurrentPage(prev => prev + 1)}
                                >
                                    ›
                                </button>

                            </div>
                        )}




                    </div>
                )}


                {(district === "DIST_ALL" || district === "" || district === null) && displayMode === "all" && (
                    <div className="itm-table-for-emp">
                        <table className="mx-auto ms-4 me-4 my-4 d-block overflow-x-auto ">
                            <thead className="itm-table-head-dash">
                                <tr >
                                    <th>S.No</th>
                                    <th>District</th>
                                    <th>No. of Employees Present</th>
                                    <th>No. of Employees Absent</th>
                                    <th>No. of Employees Not in the Location</th>
                                    <th>No. of Total Employees</th>

                                </tr>
                            </thead>
                            <tbody className="table-body-dash">
                                {differenceDayAttendace?.districts?.length > 0 ? (
                                    paginatedDistricts.map((dist, idx) => (

                                        <tr key={dist.districtId ?? idx}>
                                            <td>{indexOfFirstRecord + idx + 1}</td>
                                            <td className="text-start">{dist.districtName ?? "-"}</td>
                                            <td>{dist.presentCount ?? "-"}</td>
                                            <td>{dist.absentCount ?? "-"}</td>
                                            <td>{dist.notInLocationCount ?? "-"}</td>
                                            <td>{dist.totalEmployees ?? "-"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={6} className="py-4">
                                            {filterLoading ? "Loading…" : "No district data for the selected range."}
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                        <div className="d-flex justify-content-center my-3">
                            <button
                                className="btn btn-outline-primary btn-sm mx-1"
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(prev => prev - 1)}
                            >
                                Prev
                            </button>

                            {[...Array(totalPages)].map((_, i) => (
                                <button
                                    key={i}
                                    className={`btn btn-sm mx-1 ${currentPage === i + 1 ? "btn-primary" : "btn-outline-primary"
                                        }`}
                                    onClick={() => setCurrentPage(i + 1)}
                                >
                                    {i + 1}
                                </button>
                            ))}

                            <button
                                className="btn btn-outline-primary btn-sm mx-1"
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage(prev => prev + 1)}
                            >
                                Next
                            </button>
                        </div>

                    </div>
                )}

            </div>
        </div>
    );
};

export default PMDashboard;